import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import Loader from '@/components/Loader';
import Project from './DialogLayout';
import CloseDialogButton from '@/dialogs_common/CloseDialogButton';

ProjectManageDialog.propTypes = {
  project: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
};

export default function ProjectManageDialog(props) {
  const { project } = props;

  if (project.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-lg relative">
      <p className="text-base text-cs-gray-900 absolute top-6 left-8">Your project</p>
      <CloseDialogButton onCancel={props.onCancel} />
      <div className="px-6 pt-16 pb-6">
        <Project
          project={project}
          onClose={props.onCancel}
        />
      </div>
    </DialogTemplate>
  );
};
